import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { FilterDefinitionItem, FilterDefinitionItemLocalDate } from '../../../core/model/filter-definition-item';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { ColumnDefinitionService } from '../../../rent/service/data/column-definition.service';
import { ImdImportService } from '../../service/imd-import.service';
import { ImdImport } from '../../model/ImdImport';
import { standardCommand } from '../../../core/model/command';
import { ImdImportCommandHandlerResolver } from '../../service/command/imd-import-command-handler-resolver.service';

@Component({
    selector: 'app-imd-import-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImdImportManagerComponent extends PagedObjectManagerComponent<ImdImport> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private _dataService: ImdImportService,
    dispatcher: CommandDispatcher,
    handlerResolver: ImdImportCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = columnDefinitionService.getImdImportColumnDefinition();
    this.title = 'CONSUMPTION.IMPORT.FILE_IMPORTS';
    this.preferencesKey = 'consumption.imd-import.list';
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'CONSUMPTION.IMPORT.FILTER.IMPORT_IDENTIFIER_CONTAINS',
            'importIdentifierContains',
            definition.importIdentifierContains,
            null,
            definition.selectedFields.includes('importIdentifierContains')
          ),
          new FilterDefinitionItemLocalDate(
            'CONSUMPTION.IMPORT.FILTER.IMPORTED_EARLIEST',
            'importedFrom',
            definition.importedFrom,
            definition.selectedFields.includes('importIdentifierContains')
          ),
          new FilterDefinitionItemLocalDate(
            'CONSUMPTION.IMPORT.FILTER.IMPORTED_LATEST',
            'importedTo',
            definition.importedTo,
            definition.selectedFields.includes('importedTo')
          ),
        ];
      })
    );
    this.addContextMenuItemDefinition('DELETE_BTN', standardCommand.delete);
  }
}
